import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import  logo from "../../assets/logo/logo-nexah.png"
//import { Interface } from 'readline';

interface MenuItem {
  routing: string;
  titre: string;
  onClick?: () => void;
}

// Créer le composant NavBar
const NavBar: FC<any> = () => {
  //const  [currentpage,setcurrentpage] = useState<string>('');
  const { t } = useTranslation();
  const [activeMenu, setActiveMenu] = useState<string>("");
  return (
  <>
  <div className="flex w-full items-center flex-row h-[10%] bg-[#FAFAFA] px-[10%] justify-between ">
    <div className="flex items-center "> <img className="h-[80px] w-[233px]" src={logo} alt="" /> </div>
    <div className="flex items-center justify-center px-3 py-5 border-2 border-[#25AAE1] rounded-lg text-[#25AAE1]">  Retour a la page principale  </div>
  </div>
  </>
  );
};

export default NavBar;
